// extracted by mini-css-extract-plugin
export default {"wrapper":"k8Deowd","errorMessage":"_2jne2Ok","suggestionMessage":"_1uU5Pb0"};